import angular from "angular";

angular
    .module('app')
    .component('userRoles', {
        template: require('./user-roles.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;


    $ctrl.$onInit = function () {
        $ctrl.roles = $ctrl.resolve.roles;
        $ctrl.user = $ctrl.resolve.user;

        $ctrl.roles.forEach(function (role) {
            role.isSelected = !!$ctrl.user.roles.find(r => r.id == role.id);
        });
    };

    $ctrl.toggleRole = function (role) {
        role.isSelected = !role.isSelected;
    };

    $ctrl.save = function () {

        $ctrl.loading = true;

        let selectedRoles = $ctrl.roles.filter(r => r.isSelected);

        let rolesIds = [];
        selectedRoles.forEach(function (r) {
            rolesIds.push(r.id);
        });

        $http
            .post(`/admin/users/${$ctrl.user.id}/sync-roles`, {roles_ids: rolesIds})
            .then(
                function (response) {
                    $ctrl.user.roles = selectedRoles;

                    $ctrl.close();
                    Notifier.success('Данные успешно обновлены', 2);
                },
                function (error) {

                    $ctrl.loading = false;

                    ErrorResponseParser.parse(error);
                    Notifier.error('Произошла ошибка', 2);

                }
            );
    };

}
